import map from 'lodash/map';
import pick from 'lodash/pick';

export const propList = [
	'filters',
	'isLoading',
	'isOpenFilters',
	'noVehiclesFound',
	'pagination',
	'shouldDisplayRefreshPrompt',
	'shouldShowNoSaleMessage',
	'togglePanelFilters',
	'vehiclesCount',
	'noSaleProps',
];

export const serializeProps = (props) =>
	JSON.stringify({
		...pick(props, propList),
		vehicleIds: map(props.vehicles, 'id'),
	});

export const vehicleListPropComparer = (prevProps, nextProps) => {
	const prevList = serializeProps(prevProps);
	const nextList = serializeProps(nextProps);

	return prevList === nextList;
};
